import React, { useState } from 'react';
import { makeStyles, useTheme } from 'utils/makeStylesAdapter';
import { Box, Tooltip, Typography, CircularProgress } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import TimelineIcon from '@mui/icons-material/Timeline';
import { HeaderModal, ButtonConsensus } from 'components';
import { AssociationTimeline as CustomAssociationTimeline } from './components';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import HistoryIcon from '@mui/icons-material/History';
import associationService from 'services/association/associationService';
import { toast } from 'react-toastify';

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(0, 0, 1, 0),
  },
  timelineItem: {
    '&:before': {
      content: 'none',
    },
  },
}));

const ButtonAssociationTimeline = props => {
  const { association } = props;

  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [open, setOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    setLoading(true);
    associationService
      .getAssociationHistoryService(association?.id)
      .then(response => {
        setHistoryData(response.data);
        setLoading(false);
      })
      .catch(error => {
        toast.error('Erro ao carregar histórico:', error);
        setLoading(false);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ButtonConsensus
        title="Histórico"
        endIcon={<TimelineIcon style={{ color: '#ffffff' }} />}
        backgroundColor="#2196f3"
        hovercolor="#1976d2"
        onClick={handleOpen}
      />
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleClose}
        scroll="body"
        aria-labelledby="modal-association-timeline"
      >
        <HeaderModal onClose={handleClose}>Histórico</HeaderModal>
        <DialogContent>
          <Timeline>
            {loading ? (
              <Box textAlign="center" py={4}>
                <CircularProgress />
              </Box>
            ) : historyData.length > 0 ? (
              historyData.map((historyItem, index) => (
                <TimelineItem className={classes.timelineItem} key={historyItem?.id}>
                  <TimelineSeparator>
                    <Tooltip
                      title={
                        historyItem.fromSituation
                          ? 'Mudança de situação'
                          : historyItem.observation
                          ? 'Observação adicionada'
                          : 'Criação da instituição'
                      }
                      arrow
                      placement="top"
                    >
                      <TimelineDot style={{ backgroundColor: historyItem.observation ? '#4caf50' : '#2196f3' }}>
                        <HistoryIcon fontSize="small" style={{ color: '#ffffff' }} />
                      </TimelineDot>
                    </Tooltip>
                    {index < historyData.length - 1 && <TimelineConnector />}
                  </TimelineSeparator>
                  <TimelineContent>
                    <CustomAssociationTimeline
                      historyItem={historyItem}
                      isCreation={!historyItem.fromSituation && !historyItem.historyObservation}
                    />
                  </TimelineContent>
                </TimelineItem>
              ))
            ) : (
              <Box textAlign="center" py={4}>
                <Typography variant="body1" color="textSecondary">
                  Não há histórico de mudanças para esta instituição.
                </Typography>
              </Box>
            )}
          </Timeline>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ButtonAssociationTimeline;
